export default __webpack_public_path__ + "static/media/Logout.56c25ec2.svg";